import React, { useEffect, useRef, useState } from 'react';
import { barColor } from '../lib/api';

export const ScoreRing = ({ score, size = 148, strokeWidth = 9, animate = true, testId = 'score-ring' }) => {
  const [display, setDisplay] = useState(animate ? 0 : score || 0);
  const rafRef = useRef(null);

  const radius = (size - strokeWidth) / 2;
  const circumference = 2 * Math.PI * radius;
  const value = score == null ? 0 : score;
  const progress = (display / 100) * circumference;
  const color = barColor(score);

  useEffect(() => {
    if (score == null) return undefined;
    const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!animate || reduced) {
      setDisplay(value);
      return undefined;
    }
    const duration = 1100;
    const start = performance.now();
    const tick = (now) => {
      const p = Math.min(1, (now - start) / duration);
      const eased = 1 - Math.pow(1 - p, 3);
      setDisplay(Math.round(eased * value));
      if (p < 1) rafRef.current = requestAnimationFrame(tick);
    };
    rafRef.current = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(rafRef.current);
  }, [score, animate, value]);

  return (
    <div className="relative inline-flex items-center justify-center" style={{ width: size, height: size }}>
      <svg width={size} height={size} className="-rotate-90">
        <circle cx={size / 2} cy={size / 2} r={radius} fill="none" stroke="rgba(255,255,255,0.07)" strokeWidth={strokeWidth} />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={radius}
          fill="none"
          stroke={score == null ? 'rgba(255,255,255,0.1)' : color}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          strokeDasharray={circumference}
          strokeDashoffset={circumference - progress}
          style={{ filter: score != null ? `drop-shadow(0 0 8px ${color}66)` : 'none' }}
        />
      </svg>
      <div className="absolute inset-0 flex flex-col items-center justify-center">
        <span data-testid={testId} className="font-display font-bold tabular-nums text-4xl text-white">
          {score == null ? '\u2014' : display}
        </span>
        {score != null && <span className="font-mono text-[10px] text-white/45">/100</span>}
      </div>
    </div>
  );
};
